<div class="locataires-page">
  <header class="locataires-header">
    <div>
      <h2 class="locataires-title">{{ 'locataires.title' | translate }}</h2>
      <p class="locataires-subtitle">{{ 'locataires.subtitle' | translate }}</p>
    </div>

    <a [routerLink]="routes.ajoutLocataires" class="locataires-action-btn">
      <fa-icon icon="plus"></fa-icon>
      {{ 'locataires.add' | translate }}
    </a>
  </header>

  @if (loading) {
    <p class="locataires-status">{{ 'common.loading' | translate }}</p>
  }
  @if (error) {
    <p class="locataires-status locataires-status--error">
      {{ 'locataires.loadError' | translate }}
    </p>
  }

  @if (!loading && !error) {
    <label class="locataires-search">
      <span class="sr-only">{{ 'common.search' | translate }}</span>
      <input
        type="search"
        [(ngModel)]="query"
        [placeholder]="'locataires.searchPlaceholder' | translate"
        />
    </label>

    @if (locataires.length === 0) {
      <p class="locataires-empty">
        {{ 'locataires.empty' | translate }}
        <a [routerLink]="routes.ajoutLocataires">{{ 'locataires.add' | translate }}</a>
      </p>
    }

    @if (locataires.length > 0 && (locataires | search: query).length === 0) {
      <p class="locataires-empty">
        {{ 'locataires.noResults' | translate }}
      </p>
    }

    @if (locataires.length > 0) {
      <ul class="locataires-list">
        @for (locataire of locataires | search: query; track locataire.idLocataireDto) {
          <li>
            @if (locataire.idLocataireDto) {
              <a
                class="locataires-row"
                [class.is-inactive]="locataire.activeDto === false"
                [routerLink]="[routes.locataires, locataire.idLocataireDto]"
                >
                <div class="locataires-row-head">
                  <h3>{{ fullName(locataire) }}</h3>
                  @if (locataire.activeDto === false) {
                    <span class="locataires-badge">{{ 'locataires.inactif' | translate }}</span>
                  }
                </div>
                <p>{{ subtitle(locataire) }}</p>
                <p class="locataires-row-meta">{{ logementLabel(locataire) }}</p>
                @if (locataire.densiteAlerteDto) {
                  <p class="locataires-row-alert">
                    <fa-icon icon="circle-info"></fa-icon>
                    {{ 'locataires.densiteAlerte' | translate }}
                  </p>
                }
              </a>
            }
          </li>
        }
      </ul>
    }
  }
</div>
